import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const SeasonCardsRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;

  @media print {
    display: flex !important;
    gap: 12px !important;
    margin-top: 16px !important;
  }
`

export const SeasonCard = styled.div<{ $color: string }>`
  flex: 1;
  background: ${vimovaTheme.colors.white};
  border: 1px solid ${vimovaTheme.colors.border};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 0;
  overflow: hidden;
  position: relative;

  @media print {
    flex: 1 !important;
    background: ${vimovaTheme.colors.white} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SeasonTopBar = styled.div<{ $color: string }>`
  width: 100%;
  height: 4px;
  background: ${({ $color }) => $color};

  @media print {
    height: 4px !important;
    background: ${({ $color }) => $color} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SeasonCardContent = styled.div`
  padding: 12px 14px 16px;

  @media print {
    padding: 12px 14px 16px !important;
  }
`

export const SeasonHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    margin-bottom: 16px !important;
  }
`

export const SeasonIconCircle = styled.div<{ $color: string }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
  opacity: 0.2;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $color }) => $color};
    opacity: 1;
  }

  @media print {
    width: 16px !important;
    height: 16px !important;
    border-radius: 50% !important;
    background: ${({ $color }) => $color} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SeasonHeaderInfo = styled.div`
  display: flex;
  flex-direction: column;

  @media print {
    display: flex !important;
    flex-direction: column !important;
  }
`

export const SeasonName = styled.span`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 10px;
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 10px !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SeasonPeriod = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SeasonValue = styled.div<{ $color: string }>`
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-bottom: 8px;

  @media print {
    display: flex !important;
    align-items: baseline !important;
    gap: 6px !important;
    margin-bottom: 8px !important;
  }
`

export const SeasonHours = styled.span<{ $color: string }>`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: 26px;
  color: ${({ $color }) => $color};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: 26px !important;
    color: ${({ $color }) => $color} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SeasonUnit = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 10px;
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    font-size: 10px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ProgressBarTrack = styled.div`
  width: 100%;
  height: 5px;
  border-radius: 2.5px;
  background: ${vimovaTheme.colors.border};

  @media print {
    height: 5px !important;
    border-radius: 2.5px !important;
    background: ${vimovaTheme.colors.border} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ProgressBarFill = styled.div<{ $color: string; $percent: number }>`
  width: ${({ $percent }) => $percent}%;
  height: 5px;
  border-radius: 2.5px;
  background: ${({ $color }) => $color};

  @media print {
    width: ${({ $percent }) => $percent}% !important;
    height: 5px !important;
    border-radius: 2.5px !important;
    background: ${({ $color }) => $color} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ChartCard = styled.div`
  background: ${vimovaTheme.colors.white};
  border: 1px solid ${vimovaTheme.colors.border};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 14px;
  margin-top: 16px;

  @media print {
    background: ${vimovaTheme.colors.white} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 14px !important;
    margin-top: 16px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ChartTitle = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 12px;
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 12px !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ChartSubtitle = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textMuted};
  margin-top: 2px;

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ChartArea = styled.div`
  margin-top: 12px;
  position: relative;

  @media print {
    margin-top: 12px !important;
  }
`

export const MetricCardsRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;

  @media print {
    display: flex !important;
    gap: 12px !important;
    margin-top: 16px !important;
  }
`

export const MetricCard = styled.div`
  flex: 1;
  background: ${vimovaTheme.colors.white};
  border: 1px solid ${vimovaTheme.colors.border};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 14px;

  @media print {
    flex: 1 !important;
    background: ${vimovaTheme.colors.white} !important;
    border: 1px solid ${vimovaTheme.colors.border} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 14px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricCardTitle = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 10px;
  color: ${vimovaTheme.colors.primary};
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid ${vimovaTheme.colors.border};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 10px !important;
    color: ${vimovaTheme.colors.primary} !important;
    border-bottom: 1px solid ${vimovaTheme.colors.border} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricLabel = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textMuted};
  margin-top: 4px;

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricValue = styled.div<{ $color?: string }>`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: 20px;
  color: ${({ $color }) => $color || vimovaTheme.colors.primary};
  margin-top: 2px;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: 20px !important;
    color: ${({ $color }) => $color || vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricSmallValue = styled.span`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: 16px;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: 16px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MetricSuffix = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textMuted};
  margin-left: 4px;

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DeltaBadge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 10px;
  background: ${vimovaTheme.colors.backgroundWarm};
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.orange};
  position: absolute;
  right: 14px;
  top: 48px;

  @media print {
    padding: 4px 12px !important;
    border-radius: 10px !important;
    background: ${vimovaTheme.colors.backgroundWarm} !important;
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    color: ${vimovaTheme.colors.orange} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
